module.exports = __webpack_public_path__ + "static/media/sine500Hz.d24d82dd.mp3";